module.exports = __webpack_public_path__ + "static/media/2560@3x.833054b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2560@3x.png
// module id = 1863
// module chunks = 0